import { Prop, Vue } from 'vue-property-decorator'
import DataTableHeader from '@/shared/classes/components/data-table/data-table-header'
import DataTableBase from '@/shared/classes/components/data-table/data-table'

export default class DataTableHeaderComponent extends Vue {
  @Prop() header!: DataTableHeader
  @Prop() table!: DataTableBase
  @Prop() refresh!: () => void
}
